import { t } from "@redotech/redo-i18n";
import { Condition } from "@redotech/redo-return-core-common/return-flow/condition";
import { CONDITION_NAMES } from "@redotech/redo-return-core-common/return-flow/condition-names";
import { validateReturnTogetherItemReturnedSeparatelyCondition } from "@redotech/redo-return-core-common/return-flow/condition-validate";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export type ReturnTogetherItemReturnedSeparatelyState = void;

export const RETURN_TOGETHER_ITEM_RETURNED_SEPARATELY_NAME =
  CONDITION_NAMES[Condition.RETURN_TOGETHER_ITEM_RETURNED_SEPARATELY];

export const RETURN_TOGETHER_ITEM_RETURNED_SEPARATELY = (
  Details: React.ComponentType<
    ConditionTypeDetailsProps<ReturnTogetherItemReturnedSeparatelyState>
  >,
): ConditionType<
  ReturnTogetherItemReturnedSeparatelyState,
  Condition.ReturnTogetherItemReturnedSeparately
> => ({
  name: RETURN_TOGETHER_ITEM_RETURNED_SEPARATELY_NAME,
  description() {
    return t(
      "True when this item is part of a bundle (return-together, Shopify native bundle, or configured bundle) and the customer is returning some but not all of the bundle, false otherwise.",
    );
  },
  Details(
    props: ConditionTypeDetailsProps<ReturnTogetherItemReturnedSeparatelyState>,
  ) {
    return React.createElement(Details, props);
  },
  empty: undefined,
  fromModel() {},
  toModel() {
    return { type: Condition.RETURN_TOGETHER_ITEM_RETURNED_SEPARATELY };
  },
  valid() {
    return validateReturnTogetherItemReturnedSeparatelyCondition({}).valid;
  },
});
